import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Backpack: IconNode = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d: 'M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z',
      },
    ],
    ['path', { d: 'M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2' }],
    ['path', { d: 'M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5' }],
    ['path', { d: 'M8 10h8' }],
    ['path', { d: 'M8 18h8' }],
  ],
];

export default Backpack;
